import {useState} from 'react'
//images
import EmptyStar from '../../../../images/reviews/star-border.svg'
import FullStar from '../../../../images/reviews/star-full.svg'

//styles
import '../../styles/input/custom-input.css'
import '../../styles/input/custom-survey-qualification.css'

const CustomSurveyQualification = ({label, value, setValue ,requiredValue,labelSize,isDisabled}) => {

  return (
    <div className='custom-input' style={labelSize ? {gridTemplateColumns: `${labelSize} calc(100% - ${labelSize} - 20px)`} : {}}>
        {label && <div className='custom-input__label'>{label}:{requiredValue ? <span>*</span> : ''}</div>}
        <div className='custom-survey-container'>
          <div onClick={_=>setValue(1)} className={`custom-survey-box ${value === 1 ? 'custom-survey-box__active' : ''}`}>
            <div className='face'>
                <div className='eye left'/>
                <div className='eye right'/>
                <div className='mouth sad'/>
                <div className='brow left-brow'/>
                <div className='brow right-brow'/>
            </div>
            <span>Bad</span>
          </div>
          <div onClick={_=>setValue(2)} className={`custom-survey-box ${value === 2 ? 'custom-survey-box__active' : ''}`}>
            <div className='face'>
                <div className='eye left'/>
                <div className='eye right'/>
                <div className='mouth sad'/>
            </div>
            <span>Poor</span>
          </div>
          <div onClick={_=>setValue(3)} className={`custom-survey-box ${value === 3 ? 'custom-survey-box__active' : ''}`}>
            <div className='face'>
                <div className='eye left'/>
                <div className='eye right'/>
                <div className='mouth neutral'/>
            </div>
            <span>Not Bad</span>
          </div>
          <div onClick={_=>setValue(4)} className={`custom-survey-box ${value === 4 ? 'custom-survey-box__active' : ''}`}>
            <div className='face'>
                <div className='eye left'/>
                <div className='eye right'/>
                <div className='mouth'/>
            </div>
            <span>Good</span>
          </div>
          <div onClick={_=>setValue(5)} className={`custom-survey-box ${value === 5 ? 'custom-survey-box__active' : ''}`}>
            <div className='face'>
                <div className='eye left'/>
                <div className='eye right'/>
                <div className='mouth wide'/>
            </div>
            <span>Excellent</span>
          </div>
        </div>
    </div>
  )
}

export default CustomSurveyQualification